import { AdditionalHeader } from './core/baseRequest';
import { TokenRequest } from './tokenRequest';
import { objectToUrlEncodedString } from './core/formEncodedDataHelper';

export class VerifyAccountTokenRequest extends TokenRequest {
    constructor(username: string, public verificationToken: string) {
        super(username);
    }

    protected buildRequestInit(additionalHeaders: AdditionalHeader[]): RequestInit {
        return {
            ...super.buildRequestInit(additionalHeaders),
            method: 'POST',
            body: objectToUrlEncodedString({
                grant_type: 'verification_token',
                username: this.username,
                verification_token: this.verificationToken,
                client_id: this.clientId
            })
        };
    }
}
